export const required = field => val =>
  !!val || `${field || "This field"} is required`;
export const notBlank = field => val =>
  (typeof val === "string" && val.trim().length > 0) ||
  `${field || "This field"} is required and cannot be all blank`;
export const condRequired = (field, isRequired) => val =>
  !!val || !isRequired || (field ? `${field} is required` : "Required");
export const nDigits = (field, n) => {
  const pattern = new RegExp(`^\\d{${n}}$`);
  return val =>
    !val ||
    pattern.test(val.replace(/-/g, "")) ||
    `${field || "This field"} must be ${n} digits`;
};
export const nChars = (field, n) => {
  const pattern = new RegExp(`^\\w{${n}}$`);
  return val =>
    !val ||
    pattern.test(val.replace(/-/g, "")) ||
    `${field || "This field"} must be ${n} characters`;
};
export const maxChars = n => {
  return val => !val || val.length <= n || `Max of ${n} characters`;
};

export const minChars = n => {
  return val => !val || val.length >= n || `Minimum of ${n} characters`;
};

export const hasLowercaseCharacter = val =>
  !val || /.*[a-z].*/g.test(val) || "At least one lowercase letter";
export const hasUppercaseCharacter = val =>
  !val || /.*[A-Z].*/g.test(val) || "At least one uppercase letter";
export const hasNumberCharacter = val =>
  !val || /.*[0-9].*/g.test(val) || "At least one number";
export const hasSpecialCharacter = val =>
  !val || /.*[^A-Za-z0-9].*/g.test(val) || "At least one special character";

export const valuesMatch = (val1, val2, errorMessage) =>
  val1 === val2 || errorMessage || "Values must match";

export const passwordRegexRules = [
  hasLowercaseCharacter,
  hasUppercaseCharacter,
  hasNumberCharacter,
  hasSpecialCharacter,
  minChars(10)
];

export const zip = val =>
  !val ||
  /^[0-9]{5}(?:-[0-9]{4})?$/.test(val) ||
  "Zip Code must be 5 or 9 digits, e.g: 12345 or 12345-1234";

// the email and phoneNumber regex is taken from backend for consistency
const emailRegex = /^.+@.+\..+$/;
export const email = val => !val || emailRegex.test(val) || "Invalid email";

const phoneRegex = /^(?:[+](\d+)[^\d])?[(]?([2-9]\d{2})[)]?[- .]?(\d{3})[- .]?(\d{4})$/;
export const phoneNumber = val =>
  !val || phoneRegex.test(val) || "Must be a 10 digit number";
